export default __webpack_public_path__ + "static/media/reqEmail.307844df.svg";